import ConfirmBookingPage from './components/ConfirmBookingPage';
import useConfirmBookingController from './controllers/useConfirmBookingController';
import 'flatpickr/dist/flatpickr.min.css';

const ConfirmBooking = () => {
    const controller = useConfirmBookingController();

    return <ConfirmBookingPage {...controller} />;
};

export default ConfirmBooking;
